import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/krystal-purple.svg'
import _imports_1 from '@/assets/icons/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-486f9d74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "property_details_wrapper no-scrollbar" }
const _hoisted_2 = {
  key: 1,
  class: "historic_wrapper_header"
}
const _hoisted_3 = { class: "left_block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "count_wrapper" }, "1", -1))
const _hoisted_5 = { class: "right_block" }
const _hoisted_6 = {
  key: 0,
  class: "historic_wrapper_content"
}
const _hoisted_7 = { class: "historic_wrapper_content_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Historic Project Type", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please select what type of historic project it was.", -1))
const _hoisted_10 = { class: "historic_content_item_title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Project Type", -1))
const _hoisted_12 = { class: "historic_wrapper_content_item text__editor" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "custom_editor" }
const _hoisted_16 = {
  id: "quill-cursor-box",
  class: "temp-box desktop__cursor"
}
const _hoisted_17 = { class: "historic_wrapper_content_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Add any services that were part of the project (e.g. Electrical etc.) ", -1))
const _hoisted_19 = { class: "historic_content_item_title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Select Services", -1))
const _hoisted_21 = { class: "tw-mt-4" }
const _hoisted_22 = { class: "historic_wrapper_content_item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Add any before & after images, material or labour costs/ receipts or anything else that was used for this project. ", -1))
const _hoisted_24 = {
  key: 0,
  class: "no-dox"
}
const _hoisted_25 = { class: "tw-flex-row-between" }
const _hoisted_26 = ["onClick"]

import {
  computed,
  getCurrentInstance,
  onBeforeMount,
  reactive,
  ref,
} from "vue";
import { useStore } from "vuex";

import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import PropertySpecialismDropDownModal from "@/modules/Specialism/components/PropertySpecialismDropDownModal.vue";
import PropertySpecialismModal from "@/modules/Specialism/components/PropertySpecialismModal.vue";
import ConfirmSaveHistoricalProjectModal from "@/modules/properties/components/Modals/ConfirmSaveHistoricalProjectModal.vue";
import HistoricalProjectSavingStepsModal from "@/modules/properties/components/Modals/HistoricalProjectSavingStepsModal.vue";
import PropertyEstimateScreen from "./PropertyEstimateScreen.vue";
import PropertyTradeNetworkScreen from "./PropertyTradeNetworkScreen.vue";
import PropertyPreviewScreen from "@/modules/properties/components/PropertyPreviewScreen.vue";
import UploadProjectAttachmentsModal from "./Modals/UploadProjectAttachmentsModal.vue";
import ConfirmInviteContractorsModal from "@/modules/properties/components/Modals/ConfirmInviteContractorsModal.vue";
import { PROJECT_STORE } from "@/store/modules/project";
import { quillEditor } from "vue3-quill";
import { ElMessage } from "element-plus";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
import { PROPERTY_STORE } from "@/store/modules/property";
import historicalProjectService from "@/core/services/historical-project.service";
import {
  HistoricalProjectTypeEnum,
  HistoricalWorkFlowTypeEnum,
} from "@/core/enums/ProjectsEnum";
import moment from "moment";
import { useDisplay } from "vuetify";
import { onUpdated } from "vue";
import GeminiModel from "@/modules/project/components/common/GeminiModel.vue";
import GeminiModelForMobileView from "@/modules/project/components/common/GeminiModelForMobileView.vue";
import { watch } from "vue";
import ToolTip from "@/core/components/common/ToolTip.vue";
import { JOBS_STORE } from "@/store/modules/jobs";
import {
  displayToastMessage,
  isValidDate,
  parseJSON,
} from "@/core/utils/common";
import { USER_STORE } from "@/store/modules/user";

const DEFAULT = "default";
const ESTIMATE_SCREEN = "estimate-screen";
const TRADE_NETWORK_SCREEN = "trade-network-screen";
const PREVIEW_SCREEN = "preview-screen";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddHistoricalProject',
  props: {
  workflowType: { type: String, default: HistoricalWorkFlowTypeEnum.PROPERTY },
  selectedClient: {
    type: Object,
    default: null,
  },
  property: {
    type: Object,
    default: null,
  },

  isHistoricalDraftProjectFlow: {
    type: Boolean,
    default: false,
  },
  isTradeSideUser: {
    type: Boolean,
    default: false,
  },
},
  emits: ["on-back", "onHistoricProjectSaved"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const props = __props;
const emit = __emit;
const screenType = ref(DEFAULT);
const isPostLoadingModal = ref(false);
const isLoading = ref(false);
const internalInstance = getCurrentInstance();
const isConfirmSaveModal = ref(false);
const isShowSpecialismModal = ref(false);
const isShowProjectAttachmentUploadModal = ref(false);
const isShowConfirmContractorInviteModal = ref(false);
const cloneAttachmentDataList: any = ref([]);

const state = reactive({
  content: "",
  _content: "",
  editorOption: {
    placeholder: "Describe your project here",
    modules: {
      toolbar: [
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ direction: "rtl" }],
        [{ align: [] }],
        ["clean"],
      ],
    },
    wordCounter: {
      container: "#counter",
      unit: "word",
    },
    // more options
  },
  disabled: false,
});
const modelDetails = ref([
  {
    id: 1,
    tab: "Historic Project Specifics",
    info: "Please try to explain your project in more detail.",
    backBtnLabel: "Back To Properties",
  },
  {
    id: 2,
    tab: "Cost Details",
    info: "Please provide a details of your project cost.",
    backBtnLabel: "Back To Historic Project Specifics",
  },
  {
    id: 3,
    tab: "Invite Contractors",
    info: "Please provide details about who has worked with you on the project.",
    backBtnLabel: "Back To Estimate Details",
  },
  {
    id: 4,
    tab: "Project Review",
    backBtnLabel: "Back",
  },
]);
const validation = ref({
  projectTitle: [
    (v: any) => {
      if (v) {
        return v?.length <= 255 || "Project title is too long..";
      } else {
        return true;
      }
    },
  ],
});
const projectSpecialisms = computed(
  () => store.getters[`${PROJECT_STORE}/projectSpecialisms`]
);

const ProjectForm = computed(
  () => store.getters[`${PROJECT_STORE}/ProjectForm`]
);

const historicalProjectForm = ref({
  projectType: null,
  specialisms: [],
  title: "",
  description: "",
  property: props.property,
  attachments: [] as any,
  invitedContractors: [] as any[],

  projectEstimate: {
    estimateStartDate: null,
    estimates: [],
  },
});
const projectTypes = [
  {
    label: "Trade Verified",
    value: HistoricalProjectTypeEnum.TRADE_VERIFY,
  },
  {
    label: "DIY Project",
    value: HistoricalProjectTypeEnum.DIY_PROJECT,
  },
];
const filterProjectType = computed(() =>
  props.workflowType === HistoricalWorkFlowTypeEnum.CLIENT
    ? [
        {
          label: "Trade Verified",
          value: HistoricalProjectTypeEnum.TRADE_VERIFY,
        },
      ]
    : projectTypes
);
const projectAttachments = computed(
  () => store.getters[`${PROJECT_STORE}/projectAttachments`]
);
const isDisableNextButton = computed(() => {
  if (historicalProjectForm.value.title?.length >= 255) {
    return false;
  }
  return true;
});

const isFormValid = computed(() => {
  let isValid = false;
  //  projectAttachments.value.length &&
  if (
    historicalProjectForm.value.projectType &&
    historicalProjectForm.value.title &&
    historicalProjectForm.value.description &&
    isDisableNextButton.value
  ) {
    isValid = true;
  }
  if (screenType.value === TRADE_NETWORK_SCREEN) {
    if (
      !historicalProjectForm.value.invitedContractors.length &&
      historicalProjectForm.value.projectType ===
        HistoricalProjectTypeEnum.DIY_PROJECT
    ) {
      isValid = true;
    }
    if (
      !historicalProjectForm.value.invitedContractors.length &&
      historicalProjectForm.value.projectType ===
        HistoricalProjectTypeEnum.TRADE_VERIFY
    ) {
      isValid = false;
    }
  }

  return isValid;
});

const onClickToggleSpecialismForm = () => {
  isShowSpecialismModal.value = !isShowSpecialismModal.value;
};

const onClickToggleConfirmSave = () => {
  isConfirmSaveModal.value = !isConfirmSaveModal.value;
};

const onClickToggleUploadAttachmentUpload = () => {
  isShowProjectAttachmentUploadModal.value =
    !isShowProjectAttachmentUploadModal.value;
  if (!isShowProjectAttachmentUploadModal.value) {
    historicalProjectForm.value.attachments = projectAttachments.value;
  }
};

const onClickToggleConfirmContractorInviteModal = () => {
  isShowConfirmContractorInviteModal.value =
    !isShowConfirmContractorInviteModal.value;
};

const onClickTogglePostLoadingModal = () => {
  isPostLoadingModal.value = !isPostLoadingModal.value;
};

const onConfirmInvite = () => {
  if (screenType.value === TRADE_NETWORK_SCREEN) {
    screenType.value = PREVIEW_SCREEN;
    onClickToggleConfirmContractorInviteModal();
    return;
  }
};

const onBack = () => {
  if (screenType.value === DEFAULT) {
    currentSelectedTab.value = modelDetails.value[0];
    emit("on-back");
    return;
  }
  if (screenType.value === ESTIMATE_SCREEN) {
    currentSelectedTab.value = modelDetails.value[0];
    screenType.value = DEFAULT;
    return;
  }
  if (screenType.value === TRADE_NETWORK_SCREEN) {
    currentSelectedTab.value = modelDetails.value[1];
    screenType.value = ESTIMATE_SCREEN;
    historicalProjectForm.value.invitedContractors = [];
    return;
  }
  if (screenType.value === PREVIEW_SCREEN) {
    if (props.workflowType !== HistoricalWorkFlowTypeEnum.CLIENT) {
      historicalProjectForm.value.invitedContractors = [];
    }
    if (
      historicalProjectForm.value.projectType ==
      HistoricalProjectTypeEnum.DIY_PROJECT
    ) {
      screenType.value = ESTIMATE_SCREEN;
      currentSelectedTab.value = modelDetails.value[1];
    } else {
      screenType.value = TRADE_NETWORK_SCREEN;
      currentSelectedTab.value = modelDetails.value[2];
    }
    return;
  }
};

const formErrors = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/getFromErrors`]
);

const currentSelectedTab = ref(modelDetails.value[0]);
const estimateErrors = computed(() => {
  return store.getters[`${JOB_TEMPLATE_STORE}/getProjectEstimateErrors`];
});
const customErrors = () => {
  const errors = estimateErrors.value;
  if (formErrors.value.startDate) {
    return ElMessage.error(`Project start Date required.`);
  }

  if (errors) {
    for (let key in errors) {
      if (key !== "subErrors") {
        const mainErrorObj = errors[key];
        for (let errorKey in mainErrorObj) {
          if (
            typeof mainErrorObj[errorKey] !== "object" &&
            mainErrorObj[errorKey]
          ) {
            ElMessage.error(`${mainErrorObj[errorKey]}`);
            return;
          }
        }
      }
    }

    for (let key in errors) {
      if (errors[key].subErrors) {
        const subErrors = errors[key].subErrors;
        for (let subKey in subErrors) {
          const subErrorObj = subErrors[subKey];
          for (let errorKey in subErrorObj) {
            if (subErrorObj[errorKey]) {
              return ElMessage.error(subErrorObj[errorKey]);
            }
          }
        }
      }
    }
  }
};
const onNext = async () => {
  showButtonForGeminiModel.value = false;
  if (!isFormValid.value) return;
  if (screenType.value === DEFAULT) {
    screenType.value = ESTIMATE_SCREEN;
    currentSelectedTab.value = modelDetails.value[1];

    await store.dispatch(`${JOB_TEMPLATE_STORE}/resetErrorFields`);
    return;
  } else if (screenType.value === ESTIMATE_SCREEN) {
    const isValid = await store.dispatch(`${JOB_TEMPLATE_STORE}/validateForm`, {
      isDIYProjectType:
        historicalProjectForm.value.projectType ==
        HistoricalProjectTypeEnum.DIY_PROJECT,
    });
    if (isValid?.flag) {
      if (
        historicalProjectForm.value.projectType ==
        HistoricalProjectTypeEnum.DIY_PROJECT
      ) {
        screenType.value = PREVIEW_SCREEN;
        currentSelectedTab.value = modelDetails.value[3];
      } else {
        currentSelectedTab.value = modelDetails.value[2];
        screenType.value = TRADE_NETWORK_SCREEN;
      }
      return;
    } else {
      customErrors();
    }
  } else if (screenType.value === TRADE_NETWORK_SCREEN) {
    if (props.workflowType === HistoricalWorkFlowTypeEnum.CLIENT) {
      screenType.value = PREVIEW_SCREEN;
      currentSelectedTab.value = modelDetails.value[3];
      return;
    }
    if (historicalProjectForm.value.invitedContractors.length) {
      onClickToggleConfirmContractorInviteModal();
      currentSelectedTab.value = modelDetails.value[3];
      return;
    }
  }
};

const removeImageFromAttachments = (index: number) => {
  const attachments = projectAttachments.value;
  attachments.splice(index, 1);

  store.dispatch(`${PROJECT_STORE}/setProjectAttachments`, attachments);
};

const estimateForm = computed(() => {
  const estimates = store.getters[`${JOB_TEMPLATE_STORE}/estimateForm`];

  return estimates;
});
const formData = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/formData`]
);
const customerTotal = computed(() => {
  const total: any =
    totalSubTotal.value + totalVat.value + serviceCharges.value;
  return Math.round(parseFloat(total) * 100) / 100;
});

const totalSubTotal = computed(() => {
  const sum = estimateForm.value.projectStages.reduce(
    (sum: any, phase: any) => {
      const roundedSubTotal = parseFloat(phase.subTotal);
      return sum + roundedSubTotal;
    },
    0
  );

  return Math.round(sum * 100) / 100;
});

const totalVat = computed(() => {
  const sum = estimateForm.value.projectStages.reduce(
    (sum: any, phase: any) => {
      const roundedTotalVat = parseFloat(phase.subTotal * phase.vat);
      return sum + roundedTotalVat;
    },
    0
  );
  return Math.round(sum * 100) / 100;
});

const serviceCharges = computed(() => {
  const initialProjectCharge = 5;
  const serviceFeePercentage = 0.03; // per phase 3 % charge
  let totalWithServiceFee = estimateForm.value.projectStages.reduce(
    (sum: any, phase: any) => {
      const roundedTotalWithServiceFee = parseFloat(
        phase.subTotal * serviceFeePercentage
      );
      return sum + roundedTotalWithServiceFee;
    },
    0
  );

  totalWithServiceFee += initialProjectCharge;
  return Math.round(totalWithServiceFee * 100) / 100;
});
const projectEstimateEndDate = computed(() =>
  estimateForm.value.projectStages
    .filter((phase: any) => phase.stageType === "labour")
    .reduce((endDate: any, phase: any) => {
      return (endDate = moment(endDate).isAfter(moment(phase?.endDate))
        ? moment(endDate).format("YYYY-MM-DD")
        : moment(phase?.endDate).format("YYYY-MM-DD"));
    }, "")
);
const projectEstimatePayload = () => {
  let estimationPhaseData = [] as any;
  if (estimateForm.value) {
    estimateForm.value.projectStages.map((estimate: any, index: number) => {
      const estimateRecord = {
        phaseName: estimate.name,
        phaseType: estimate.stageType === "labour" ? 1 : 2,
        durationType: estimate.durationType,
        phaseStartDate: estimate.startDate,
        phaseEndDate: estimate.endDate,
        vat: estimate.vat,
        subTotal:
          typeof estimate.subTotal === "number"
            ? estimate.subTotal.toString()
            : estimate.subTotal,
        phaseOrder: estimate.phaseOrder,
        estimationPhaseTasks: [],
        estimationPhaseProperties: estimate.estimationPhaseProperties,
        color: estimate.color,
        user: { id: estimate?.user?.id },
        workStation: { id: estimate?.workStation?.id },
        estimatePhaseAttachment: estimate.attachments.map((data: any) => {
          return data.uploadedImages.id;
        }),
      };

      if (estimate?.projectStageTasks && estimate?.projectStageTasks?.length) {
        estimate.projectStageTasks.map((task: any) => {
          const estimateTask: any = {
            name: task.name,
            phaseTaskStartDate: task.startDate,
            phaseTaskEndDate: task.endDate,
            durationType: task.durationType,
            taskCost:
              typeof task.taskCost === "number"
                ? task.taskCost.toString()
                : task.taskCost,
            estimationPhaseTasksProperties: task.estimationPhaseTasksProperties,
            materialUnit: task.materialUnit?.toString(),
          } as any;

          estimateRecord.estimationPhaseTasks.push(estimateTask);
        });
      }
      estimationPhaseData.push(estimateRecord);
    });
  }
  const payload = {
    id: formData?.value.id,
    grantType: formData?.value.grantType,
    grantName: formData?.value.grantName,
    grantAmount: formData?.value.grantAmount,
    totalEstimateCost:
      historicalProjectForm.value.projectType ==
      HistoricalProjectTypeEnum.DIY_PROJECT
        ? formData.value?.totalCost || 0
        : customerTotal.value,
    suggestedStartDate: formData?.value.suggestedStartDate,
    estimationPhaseData,
  };
  return payload;
};

const onSaveProject = async () => {
  try {
    isLoading.value = true;
    historicalProjectForm.value.attachments =
      await uploadHistoricalAttachment();
    const filterInviteMembers =
      historicalProjectForm.value?.invitedContractors.map((member: any) => {
        return { email: member?.email, userId: member?.toUser?.id };
      });

    const projectSpecialismsIds = projectSpecialisms.value.map((data: any) => {
      return data.id;
    });

    const payload = {
      updateProjectId: getCurrentHistoricalDraftProject.value?.id || null,
      propertyId: propertyDetails.value?.localData.id,
      projectJobStatusId: 0,
      name: historicalProjectForm.value?.title,
      description: historicalProjectForm.value?.description,
      startDate: formData.value.suggestedStartDate,
      endDate: isValidDate(projectEstimateEndDate.value)
        ? projectEstimateEndDate.value
        : formData.value.suggestedStartDate,
      historicalProjectType: historicalProjectForm.value?.projectType,
      inviteMembers: filterInviteMembers,
      attachments: historicalProjectForm.value?.attachments,
      projectEstimate: projectEstimatePayload(),
      categories: projectSpecialismsIds,
      workflowType: props.workflowType,
    };
    if (
      historicalProjectForm.value.projectType ==
      HistoricalProjectTypeEnum.DIY_PROJECT
    ) {
      delete payload.endDate;
    }
    const formDataObj = new FormData();
    estimateForm.value?.projectStages?.map((stage: any) => {
      stage.attachments?.forEach((attachment: any, index: number) => {
        formDataObj.append(
          `${attachment.uploadedImages.id}`,
          attachment.uploadedImages.imageData
        );
      });
    });
    formDataObj.append("projectData", JSON.stringify(payload));
    await historicalProjectService.createHistoricalProject(formDataObj);
    onClickTogglePostLoadingModal();
  } catch (error) {
    console.log("error", error);
  } finally {
    resetHistoricalData();
    isLoading.value = false;
    onClickToggleConfirmSave();
  }
};
const getCurrentHistoricalDraftProject = computed(
  () => store.getters[`${JOBS_STORE}/getCurrentHistoricalDraftProject`]
);
const getUploadedAttachment = async () => {
  try {
    if (!projectAttachments.value?.length) return;
    const formData = new FormData();
    projectAttachments.value.forEach((attachment: any) => {
      if (attachment?.uploadedImages?.imageData)
        formData.append(`files`, attachment.uploadedImages.imageData);
    });
    const uploadMultipleImage = await store.dispatch(
      `${USER_STORE}/uploadMultipleImage`,
      formData
    );

    return uploadMultipleImage;
  } catch (error) {
    console.log("error", error);
  }
};
const isSaveDraftloading = ref(false);
const saveHistoricalProjectToDraft = async () => {
  try {
    if (!isFormValid.value) return;
    isSaveDraftloading.value = true;
    historicalProjectForm.value.attachments = projectAttachments.value;
    const filterInviteMembers =
      historicalProjectForm.value?.invitedContractors.map((member: any) => {
        return { email: member?.email, userId: member?.toUser?.id };
      });

    const projectSpecialismsIds = projectSpecialisms.value.map((data: any) => {
      return data.id;
    });

    const payload = {
      propertyId: propertyDetails.value?.localData.id,
      projectJobStatusId: 0,
      name: historicalProjectForm.value?.title,
      description: historicalProjectForm.value?.description,
      startDate: formData.value.suggestedStartDate,
      endDate: isValidDate(projectEstimateEndDate.value)
        ? projectEstimateEndDate.value
        : formData.value.suggestedStartDate,
      historicalProjectType: historicalProjectForm.value?.projectType,
      inviteMembers: filterInviteMembers,
      attachments: historicalProjectForm.value?.attachments,
      projectEstimate: projectEstimatePayload(),
      categories: projectSpecialismsIds,
      workflowType: props.workflowType,
    };
    if (
      historicalProjectForm.value.projectType ==
      HistoricalProjectTypeEnum.DIY_PROJECT
    ) {
      delete payload.endDate;
    }
    const uploadedAttachment = await getUploadedAttachment();
    const draftProjectPayload = {
      updateProjectId: getCurrentHistoricalDraftProject.value?.id || null,
      propertyId: payload.propertyId,
      name: payload.name,
      description: payload.description,
      historicalProjectType: payload.historicalProjectType,
      draftHistoricalProjectData: JSON.stringify({
        estimateForm: estimateForm.value,
        formData: formData.value,
        historicalProjectForm: historicalProjectForm.value,
        projectSpecialisms: projectSpecialisms.value,
        uploadedAttachment,
      }),
    };

    await store.dispatch(
      `${JOBS_STORE}/saveDraftHistoricalProjects`,
      draftProjectPayload
    );
    displayToastMessage(
      internalInstance,
      `Save Project To Draft Successfully !`,
      "success"
    );
  } catch (error) {
    console.log("save draft project error", error);
  } finally {
    isSaveDraftloading.value = false;
  }
};
const resetHistoricalData = () => {
  // empty Attachments
  store.dispatch(`${PROJECT_STORE}/setProjectAttachments`, []);
  // empty specialisms
  store.dispatch(`${PROJECT_STORE}/setProjectSpecialisms`, []);
  store.dispatch(`${JOB_TEMPLATE_STORE}/resetFormAndData`);
};
const onConfirmProjectType = (type: HistoricalProjectTypeEnum) => {
  if (type === HistoricalProjectTypeEnum.TRADE_VERIFY) {
    historicalProjectForm.value.projectType =
      HistoricalProjectTypeEnum.DIY_PROJECT as any;
  } else {
    historicalProjectForm.value.projectType =
      HistoricalProjectTypeEnum.TRADE_VERIFY as any;
  }
  onClickToggleConfirmContractorInviteModal();
};
const onCancelProjectType = () => {
  onConfirmInvite();
  historicalProjectForm.value.projectType =
    HistoricalProjectTypeEnum.DIY_PROJECT as any;
};
const onSaveSuccess = () => {
  onClickTogglePostLoadingModal();
  emit("on-back", true);
  emit("onHistoricProjectSaved");
};

const onSelectContractors = (selectedContractors: any) => {
  historicalProjectForm.value.invitedContractors = selectedContractors;
};
const propertyProjects = computed(
  () => store.getters[`${PROPERTY_STORE}/propertyProjects`]
);
const propertyDetails = computed(
  () => store.getters[`${PROPERTY_STORE}/propertyDetails`]
);

const onClickEditDetailsSave = (details: any) => {
  if (details.title) {
    historicalProjectForm.value.title = details.title;
  }
  if (details.description) {
    historicalProjectForm.value.description = details.description;
  }
};
const specialismCategoryClass = (val: any) => {
  if (val.toLowerCase() === "krystal") {
    return "krystal";
  }
  if (val.toLowerCase() === "property") {
    return "property";
  }
  if (val.toLowerCase() === "trade") {
    return "trade";
  }
};
const uploadHistoricalAttachment = async () => {
  if (projectAttachments.value.length) {
    try {
      const formData = new FormData();
      const newAttachment = [];
      projectAttachments.value.forEach((attachment: any) => {
        if (!attachment?.isUploaded) {
          formData.append(`files`, attachment.uploadedImages.imageData);
          newAttachment.push(attachment);
        }
      });
      const uploadMultipleImage = await store.dispatch(
        `${USER_STORE}/uploadMultipleImage`,
        formData
      );
      const alreadyUploadedAttachment = projectAttachments.value.filter(
        (attachment: any) => attachment?.isUploaded
      );
      const attachmentCategoryData: any = [];

      for (const attachment of cloneAttachmentDataList.value) {
        const existCategory = attachmentCategoryData.find(
          (category: any) => category.label === attachment.userCategoryName
        );
        if (existCategory) {
          attachmentCategoryData.push(existCategory);
        } else {
          const response = await store.dispatch(
            `${PROJECT_STORE}/attachmentCategory`,
            {
              label: attachment.userCategoryName,
              value: attachment.userCategoryName,
            }
          );
          attachmentCategoryData.push(response);
        }
      }

      const attachments: any = [
        ...uploadMultipleImage,
        ...alreadyUploadedAttachment,
      ].map((item, index) => {
        const attachment = projectAttachments.value.find(
          (attachment: any) =>
            attachment.uploadedImages.name === item.originalName
        );
        const category = attachmentCategoryData.find(
          (category: any) => category.label === attachment.userCategoryName
        );
        return {
          publicUrl: item.publicUrl,
          attachment: item.attachment,
          originalName: item.originalName,
          propertyIds: [
            {
              propertyId: propertyDetails.value?.localData.id,
              isDeleted: false,
            },
          ],
          attachmentCategoryId: category?.id,
          isDeleted: false,
        };
      });
      return attachments;
    } catch (error) {
      console.log();
      return [];
    }
  }
};
const onClickSaveRecord = (payload: any) => {
  cloneAttachmentDataList.value = payload;
  onClickToggleConfirmSave();
};

const showButtonForGeminiModel = ref(false);
const vuetify = useDisplay();
const geminiModalMenu = ref(false);
const quillInstance = ref();
const quillCursorIndex = ref(0);
const isTitleKrystalIconClick = ref(false);
const showGeminiModel = ref(false);
const showGeminiModelForMobile = ref(false);
const isMobileView = computed(() => vuetify.smAndDown.value);
const onEditorReady = (quill: any) => {
  quillInstance.value = quill;
};

onUpdated(() => {
  if (currentSelectedTab.value?.id !== 1) return;
  const toolbarElement = document.querySelector(".ql-toolbar") as HTMLElement;
  if (!toolbarElement) return;
  const topPadding = toolbarElement?.offsetHeight || 63;
  if (isMobileView.value) {
    const cursorBox: any = document.getElementById(
      "quill-cursor-box-mobile"
    ) as HTMLElement;
    if (cursorBox) cursorBox.style.top = `${topPadding + 12 + 67}px`;
  } else {
    const cursorBox: any = document.getElementById("quill-cursor-box");
    if (cursorBox) cursorBox.style.top = `${topPadding + 12 + 67}px`;
  }
});

const onEditorChange = ({
  quill,
  html,
  text,
}: {
  quill: any;
  html: string;
  text: string;
}) => {
  try {
    quillInstance.value = quill;
    showButtonForGeminiModel.value = false;

    const range = quill.getSelection();

    const [clientX, clientY]: any = getCaretCoordinates(quill, range?.index);

    const toolbarElement = document.querySelector(".ql-toolbar") as HTMLElement;
    const topPadding = toolbarElement.offsetHeight;

    if (isMobileView.value) {
      const cursorBox: any = document.getElementById("quill-cursor-box-mobile");
      if (cursorBox) {
        cursorBox.style.top = `${clientY + topPadding + 67}px`;
        cursorBox.style.left = `${clientX + 10}px`;
      }
    } else {
      const cursorBox: any = document.getElementById("quill-cursor-box");
      if (cursorBox) {
        cursorBox.style.top = `${clientY + topPadding + 67}px`;
        cursorBox.style.left = `${clientX + 10}px`;
      }
    }

    state._content = html;
    quillCursorIndex.value = range?.index;
    showButtonForGeminiModel.value = true;
  } catch (error) {
    console.log(error);
  }
};

const getCaretCoordinates = (quill: any, index: any) => {
  try {
    const editorBounds = quill?.container.getBoundingClientRect();
    const range = document.createRange();
    const leaf = quill?.getLeaf(index)[0];
    const node = leaf?.domNode;
    const offset = index - leaf?.offset(quill.root);

    range.setStart(node, offset);
    range.setEnd(node, offset);

    const rect = range.getBoundingClientRect();
    return [rect.left - editorBounds?.left, rect.top - editorBounds?.top];
  } catch (error) {
    console.log(error);
  }
};
const appendJobDescription = (description: string) => {
  if (isTitleKrystalIconClick.value) {
    historicalProjectForm.value.title = description.replaceAll("\n", " ");
    isTitleKrystalIconClick.value = false;
  } else {
    quillInstance.value.focus();
    quillInstance.value?.insertText(
      quillCursorIndex.value,
      description.replaceAll("\n", " ")
    );
  }
  onCloseHandler();
};
const onCloseHandler = () => {
  geminiModalMenu.value = false;
  showGeminiModel.value = false;
  showGeminiModelForMobile.value = false;
  quillInstance?.value?.focus();
};

const onEditorFocus = (quill: any) => {
  try {
    showButtonForGeminiModel.value = true;
    quillInstance.value = quill;
    const range = quill.getSelection();
    quill.insertText(range?.index, "");
  } catch (error) {
    console.log(error);
  }
};
const onClickTitleKrystalIcon = () => {
  isTitleKrystalIconClick.value = true;
  showGeminiModelForMobile.value = true;
};

watch(
  () => isMobileView.value,
  () => {
    showButtonForGeminiModel.value = false;
  }
);

onBeforeMount(() => {
  if (props.isHistoricalDraftProjectFlow) {
    const draftHistoricalProjectData = parseJSON(
      getCurrentHistoricalDraftProject.value?.draftHistoricalProjectData
    );
    if (draftHistoricalProjectData?.historicalProjectForm) {
      historicalProjectForm.value =
        draftHistoricalProjectData.historicalProjectForm;
    }
  } else {
    if (props.selectedClient)
      historicalProjectForm.value.invitedContractors = [props.selectedClient];

    resetHistoricalData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        (currentSelectedTab.value.id !== 4)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "back_button",
              onClick: onBack,
              variant: "tonal",
              "prepend-icon": "mdi-chevron-left"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(currentSelectedTab.value.backBtnLabel), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (screenType.value !== PREVIEW_SCREEN)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h5", null, [
                  _hoisted_4,
                  _createTextVNode(_toDisplayString(currentSelectedTab.value?.tab), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(currentSelectedTab.value?.info), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_btn, {
                  disabled: !isFormValid.value || isSaveDraftloading.value,
                  onClick: onNext,
                  class: "button button-orange"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Continue")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                (!__props.isTradeSideUser)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      disabled: !isFormValid.value || isSaveDraftloading.value,
                      class: "save-btn bright-blue-text",
                      onClick: saveHistoricalProjectToDraft,
                      variant: "text",
                      loading: isSaveDraftloading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" save project to draft ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (screenType.value === DEFAULT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_v_select, {
                  items: filterProjectType.value,
                  class: "custom_input_field",
                  placeholder: "Select Project Type",
                  density: "compact",
                  "item-value": "value",
                  "item-title": "label",
                  "model-value": historicalProjectForm.value.projectType,
                  variant: "outlined",
                  "menu-props": { contentClass: 'project_type__selector' }
                }, {
                  item: _withCtx(({ props, item }) => [
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                          modelValue: historicalProjectForm.value.projectType,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((historicalProjectForm.value.projectType) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, _mergeProps({ color: "#4b4bff" }, props, {
                              label: item.raw.label,
                              value: item.raw.value
                            }), null, 16, ["label", "value"]),
                            _createVNode(ToolTip, {
                              description: 
                      item.raw.value === _unref(HistoricalProjectTypeEnum).TRADE_VERIFY
                        ? 'This project has been verified by a professional. You may include additional details if available.'
                        : 'DIY - This project was done by yourself. Include before/after images, costs, and materials used.'
                    
                            }, null, 8, ["description"])
                          ]),
                          _: 2
                        }, 1032, ["modelValue"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["items", "model-value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_v_text_field, {
                class: "projecttitle_select",
                placeholder: "Project Title/ Name",
                modelValue: historicalProjectForm.value.title,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((historicalProjectForm.value.title) = $event)),
                variant: "underlined",
                density: "compact",
                rules: validation.value.projectTitle
              }, {
                "append-inner": _withCtx(() => [
                  _createElementVNode("div", { onClick: onClickTitleKrystalIcon }, _hoisted_14)
                ]),
                _: 1
              }, 8, ["modelValue", "rules"]),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("div", _hoisted_16, null, 512), [
                  [_vShow, showButtonForGeminiModel.value]
                ]),
                _createVNode(_component_v_menu, {
                  modelValue: geminiModalMenu.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((geminiModalMenu).value = $event)),
                  activator: "#quill-cursor-box",
                  transition: "scale-transition",
                  target: "cursor",
                  location: "bottom",
                  "close-on-content-click": false,
                  "close-on-back": false,
                  class: "desktop__cursor"
                }, {
                  default: _withCtx(() => [
                    _createVNode(GeminiModel, {
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                      onAppendJobDescription: appendJobDescription,
                      onOnClose: onCloseHandler
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _withDirectives(_createElementVNode("div", {
                  id: "quill-cursor-box-mobile",
                  class: "temp-box mobile__cursor",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showGeminiModelForMobile.value = !showGeminiModelForMobile.value))
                }, null, 512), [
                  [_vShow, showButtonForGeminiModel.value]
                ]),
                _createVNode(_unref(quillEditor), {
                  value: historicalProjectForm.value.description,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((historicalProjectForm.value.description) = $event)),
                  options: state.editorOption,
                  disabled: state.disabled,
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (onEditorChange($event))),
                  onFocus: _cache[7] || (_cache[7] = ($event: any) => (onEditorFocus($event))),
                  onReady: onEditorReady,
                  class: "editor_ql"
                }, null, 8, ["value", "options", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h4", null, [
                _createTextVNode(" Services "),
                _createVNode(ToolTip, { description: "Services are optional for DIY but are required for the Trade Verified Historic Projects." })
              ]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(PropertySpecialismDropDownModal)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("h4", null, [
                _createTextVNode("Upload files "),
                _createVNode(ToolTip, { description: "Upload Media" })
              ]),
              _hoisted_23,
              _createElementVNode("div", {
                class: _normalizeClass(["historic_content_media_upload", { 'tw-flex-col !tw-items-start': projectAttachments.value.length }])
              }, [
                (!projectAttachments.value.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, " No documents added "))
                  : _createCommentVNode("", true),
                _createVNode(Button, {
                  label: "Add Documents",
                  variant: "tertiary",
                  background: "transparent",
                  class: "!tw-w-auto !tw-capitalize !tw-text-xs tw-tracking-normal !tw-p-0 !tw-h-auto !tw-min-h-auto !tw-font-normal !tw-text-[#0C0F4A] !tw-bg-transparent",
                  onClick: onClickToggleUploadAttachmentUpload
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-plus-circle",
                      color: "#FAA500"
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectAttachments.value, (attachment, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "tw-w-full tw-flex tw-flex-col tw-gap-1 tw-items-start tw-border-b-solid-custom tw-pb-4 tw-box-border"
                  }, [
                    _createVNode(_component_v_img, {
                      class: _normalizeClass(["tw-rounded-lg", {
                'tw-hidden':
                  attachment?.uploadedImages?.imageData.type ===
                    'application/pdf' ||
                  attachment?.uploadedImages?.imageData.type ===
                    'application/msword' ||
                  !attachment?.type?.includes('image'),
              }]),
                      width: 156,
                      height: 88,
                      "aspect-ratio": "16/9",
                      cover: "",
                      src: attachment?.uploadedImages?.url
                    }, null, 8, ["class", "src"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(Text, { variant: "span" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(attachment?.uploadedImages?.name), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("img", {
                        class: "tw-cursor-pointer",
                        onClick: ($event: any) => (removeImageFromAttachments(index)),
                        src: _imports_1
                      }, null, 8, _hoisted_26)
                    ])
                  ]))
                }), 128))
              ], 2)
            ]),
            _createVNode(Button, {
              label: "next",
              class: "!tw-max-w-full !tw-hidden lg:!tw-hidden md:!tw-block",
              onClick: onNext,
              isActive: isFormValid.value
            }, null, 8, ["isActive"])
          ]))
        : _createCommentVNode("", true),
      (screenType.value === ESTIMATE_SCREEN)
        ? (_openBlock(), _createBlock(PropertyEstimateScreen, {
            key: 1,
            historicalProjectForm: historicalProjectForm.value,
            isTradeSideUser: __props.isTradeSideUser,
            propertyDetails: propertyDetails.value?.localData,
            onOnNext: onNext
          }, null, 8, ["historicalProjectForm", "isTradeSideUser", "propertyDetails"]))
        : _createCommentVNode("", true),
      (screenType.value === TRADE_NETWORK_SCREEN)
        ? (_openBlock(), _createBlock(PropertyTradeNetworkScreen, {
            key: 2,
            inviteContractors: historicalProjectForm.value.invitedContractors,
            selectedClient: __props.selectedClient,
            propertyDetails: propertyDetails.value?.localData,
            onOnSelectContractor: onSelectContractors,
            workflowType: __props.workflowType,
            onOnNext: onNext
          }, null, 8, ["inviteContractors", "selectedClient", "propertyDetails", "workflowType"]))
        : _createCommentVNode("", true),
      (screenType.value === PREVIEW_SCREEN)
        ? (_openBlock(), _createBlock(PropertyPreviewScreen, {
            key: 3,
            propertyDetails: propertyDetails.value?.localData,
            historicalProjectForm: historicalProjectForm.value,
            onOnBack: onBack,
            onOnSaveRecord: onClickSaveRecord,
            onOnEditDetails: onClickEditDetailsSave,
            onOnSelectContractor: onSelectContractors,
            workflowType: __props.workflowType,
            onOnSaveDraft: saveHistoricalProjectToDraft,
            isTradeSideUser: __props.isTradeSideUser,
            isSaveDraftloading: isSaveDraftloading.value
          }, null, 8, ["propertyDetails", "historicalProjectForm", "workflowType", "isTradeSideUser", "isSaveDraftloading"]))
        : _createCommentVNode("", true)
    ]),
    (isShowSpecialismModal.value)
      ? (_openBlock(), _createBlock(PropertySpecialismModal, {
          key: 0,
          onOnClickCloseTab: onClickToggleSpecialismForm
        }))
      : _createCommentVNode("", true),
    (isConfirmSaveModal.value)
      ? (_openBlock(), _createBlock(ConfirmSaveHistoricalProjectModal, {
          key: 1,
          loading: isLoading.value,
          onOnClose: onClickToggleConfirmSave,
          onOnConfirm: onSaveProject,
          projectType: historicalProjectForm.value.projectType
        }, null, 8, ["loading", "projectType"]))
      : _createCommentVNode("", true),
    (isPostLoadingModal.value)
      ? (_openBlock(), _createBlock(HistoricalProjectSavingStepsModal, {
          key: 2,
          onOnSuccess: onSaveSuccess
        }))
      : _createCommentVNode("", true),
    (isShowProjectAttachmentUploadModal.value)
      ? (_openBlock(), _createBlock(UploadProjectAttachmentsModal, {
          key: 3,
          projectAttachments: projectAttachments.value,
          isPropertyOwner: true,
          onOnClose: onClickToggleUploadAttachmentUpload
        }, null, 8, ["projectAttachments"]))
      : _createCommentVNode("", true),
    (isShowConfirmContractorInviteModal.value)
      ? (_openBlock(), _createBlock(ConfirmInviteContractorsModal, {
          key: 4,
          projectType: historicalProjectForm.value.projectType,
          historicalProjectForm: historicalProjectForm.value,
          onOnClose: onClickToggleConfirmContractorInviteModal,
          onOnConfirm: onConfirmInvite,
          onOnCancel: onCancelProjectType,
          onOnConfirmProjectType: onConfirmProjectType
        }, null, 8, ["projectType", "historicalProjectForm"]))
      : _createCommentVNode("", true),
    (showGeminiModelForMobile.value)
      ? (_openBlock(), _createBlock(GeminiModelForMobileView, {
          key: 5,
          onAppendJobDescription: appendJobDescription,
          onOnClose: onCloseHandler
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_stepper, {
      class: "onboard-stepper",
      modelValue: currentSelectedTab.value.id,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((currentSelectedTab.value.id) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelDetails.value, (step) => {
              return (_openBlock(), _createBlock(_component_v_stepper_item, {
                class: "onboard-stepper__item",
                key: step.id,
                title: step.tab,
                value: step.id,
                style: _normalizeStyle({
          display:
            historicalProjectForm.value.projectType ==
              _unref(HistoricalProjectTypeEnum).DIY_PROJECT && step.id == 3
              ? 'none'
              : 'flex',
        })
              }, null, 8, ["title", "value", "style"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})